import {
  COMPONENT_VALUE_TYPES as types,
  BACKGROUND_IMAGE_POSITION,
  COMPONENT_COLOR_THEMES
} from 'shared/constants';

const propsSchema = [
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'tabs',
    label: 'Tabs',
    type: types.ARRAY,
    children: [
      {
        key: 'title',
        label: 'Tab Title',
        type: types.TEXT
      },
      {
        key: 'caption_title',
        label: 'Caption Title',
        type: types.TEXT
      },
      {
        key: 'caption_desc',
        label: 'Caption Description',
        type: types.TEXT
      },
      {
        key: 'caption_position',
        label: 'Caption Position',
        type: types.ENUM,
        options: BACKGROUND_IMAGE_POSITION
      },
      {
        key: 'color_theme',
        label: 'Color Theme',
        type: types.ENUM,
        options: COMPONENT_COLOR_THEMES
      },
      {
        key: 'img',
        label: 'Image(s)',
        type: types.ARRAY,
        children: [
          {
            key: 'url',
            label: 'url',
            type: types.TEXT
          }
        ]
      }
    ]
  },
  {
    key: 'show_mobile_title',
    label: 'Show Title on Mobile',
    type: types.BOOLEAN
  },
  {
    key: 'is_horizontal_tab',
    label: 'Horizontal Tabs (Disabled for Vertical Tabs)',
    type: types.BOOLEAN
  }
];

const defaultProps = {
  color_theme: 'DARK',
  tabs: [
    {
      title: 'Our First Flagship Vehicle',
      caption_title: 'Our First Flagship Vehicle',
      caption_desc: 'Inspired by NASA zero gravity design, the driver’s seat allows for a true sense of weightlessness. Rising from the exposed carbon fiber vehicle structure itself, the seat drastically reduces the stress on the driver’s body at high speeds.',
      caption_position: 'LEFT TOP',
      img: [
        {
          url: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-01.jpg',
        },
        {
          url: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-02.jpg',
        },
        {
          url: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-03.jpg',
        }
      ],
      color_theme: 'DARK'
    },
    {
      title: 'Zero Gravity Driving Position',
      caption_title: 'Zero Gravity Driving Position',
      caption_desc: 'Inspired by NASA zero gravity design, the driver’s seat allows for a true sense of weightlessness. Rising from the exposed carbon fiber vehicle structure itself, the seat drastically reduces the stress on the driver’s body at high speeds.',
      caption_position: 'LEFT TOP',
      img: [
        {
          url: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-04.jpg'
        }
      ],
      color_theme: 'LIGHT'
    },
    {
      title: 'Advanced Ergonomics',
      caption_title: 'Advanced Ergonomics',
      caption_desc: 'Every element of this vehicle has been sculpted around the driver’s form. This includes the signature asymmetric instrument panel that runs seamlessly into the halo safety structure.',
      caption_position: 'LEFT BOTTOM',
      img: [
        {
          url: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-05.jpg'
        }
      ],
      color_theme: 'DARK'
    },
    {
      title: 'Unique Materials',
      caption_title: 'Unique Materials',
      caption_desc: 'Highlighting the contrast between dark and light, matte and high gloss, and smooth and three dimensional textures, the interior blends holistically with elements of the exterior to create a strikingly clean, elegant, and pure way of conveying confident power.',
      caption_position: 'LEFT CENTER',
      img: [
        {
          url: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-06.jpg'
        }
      ],
      color_theme: 'DARK'
    }
  ],
  show_mobile_title: true,
  is_horizontal_tab: true
};

export default {
  title: 'Flexible Gallery',
  id: 'FlexibleGallery',
  propsSchema,
  defaultProps
};
